Ext.define('SA.model.ImportDataset', {
    constructor({id, name, censusReleaseYear, edition, vendorName, countryCode}) {
        this.id = id;
        this.name = name;
        this.censusReleaseYear = censusReleaseYear;
        this.edition = edition;
        this.countryCode = countryCode;
        this.vendorName = vendorName;
    },

    getId() {
        return this.id;
    },

    getName() {
        return this.name;
    },

    getVendorName() {
        return this.vendorName;
    },

    hasCensusReleaseYear(censusReleaseYear) {
        return censusReleaseYear === this.censusReleaseYear;
    },

    hasCountryCode(countryCode) {
        return countryCode === this.countryCode;
    },

    hasEditionInCensusRelease({edition, censusReleaseYear}) {
        if (!this.hasCensusReleaseYear(censusReleaseYear)) {
            return false;
        }

        return this.edition === edition;
    },

    hasFolders() {
        return true;
    },

    isACS() {
        return false;
    },

    isAnyScarborough() {
        return false;
    },

    isImport() {
        return true;
    },

    isPolygon() {
        return true;
    },

    isPremium() {
        return false;
    },

    isScarboroughCrosstab() {
        return false;
    },

    isScarboroughNonCrosstab() {
        return false;
    },

    isSimmonsCrosstab() {
        return false;
    },

    isStandard() {
        return false;
    }
});